/**
 * **********************************************
 * Topic to be consider during development phase
 * **********************************************
 * 
 * Todo List
 * Add, delete 
 * all, Active, Completed, Archived \
 * Use of localStorage to persist information
 * Use of Context API
 *
 * Develop in Scratch and convert it into Typescript 
 */

import { useContext, useEffect, useState } from 'react';
import TaskList from './components/TaskList';
import FilterList from './components/FilterList';
import Popup from './components/Popup';
import Toast from './components/Toast'
import { getFormatDate } from './utils';
import { FaPlus } from 'react-icons/fa6';
import './App.scss';
import { AppContext } from './context/AppContext';

function App() {
  const [isOpen, setOpen] = useState(false);
  const [isToastOpen, setToastOpen] = useState(false);
  const [toastProps, setToastProps] = useState({
    variant: '',
    message: ''
  })
  const {state: {todoList}} = useContext(AppContext);
  const currentDate = new Date();

  const filterProps = {
    todoList,
  } 
  useEffect(() => {
    document.body.classList.add('bg-blue-50');
  },[]) 

  return (
    <div className={"App"}>
      <header className="App-header">
        <div>
          <h4 className="title text-blue-600 font-bold">Today's Task</h4>
          <p className="timestamp font-[500]">{getFormatDate(currentDate)}</p>
        </div>

        <button className="add-task bg-blue-100 text-blue-600 font-[500]" onClick={() => {
          setOpen(true);
        }}><FaPlus /> Add task</button>
      </header>
      <section>
        <FilterList {...filterProps} />
        <TaskList setToastOpen={setToastOpen} setToastProps={setToastProps} toastProps={toastProps}  />
      </section>
      {isOpen && <Popup setToastOpen={setToastOpen} setToastProps={setToastProps} toastProps={toastProps} setOpen={setOpen} />}
      {isToastOpen && <Toast {...toastProps} setToastOpen={setToastOpen} />}
    </div>
  );
}
export default App;